import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth, homeFor } from "./context/AuthContext";
import { CurrencyGate } from "./components/CurrencyGate";
import PaymentResult from "./pages/PaymentResult";
import Watch from "./pages/Watch";
import AdminVideos from "./pages/admin/AdminVideos";
import AppLayout from "./components/AppLayout";
import Landing from "./pages/Landing";
import AuthPage from "./pages/AuthPage";
import Certificate from "./pages/Certificate";
import StaffHome from "./pages/staff/StaffHome";
import Resume from "./pages/staff/Resume";
import Academy from "./pages/staff/Academy";
import Learn from "./pages/staff/Learn";
import JobBoard from "./pages/staff/JobBoard";
import Attendance from "./pages/staff/Attendance";
import Tasks from "./pages/Tasks";
import Timesheet from "./pages/Timesheet";
import EmployerHome from "./pages/employer/EmployerHome";
import EmployerJobs from "./pages/employer/EmployerJobs";
import JobDetail from "./pages/employer/JobDetail";
import Team from "./pages/employer/Team";
import AdminHome from "./pages/admin/AdminHome";
import TrainStaff from "./pages/employer/TrainStaff";
import CourseContent from "./pages/admin/CourseContent";
import LearnerProgress from "./pages/admin/LearnerProgress";

const RoleHome = () => {
  const { user } = useAuth();
  if (user === null) return null;
  return <Navigate to={user ? homeFor(user.role) : "/login"} replace />;
};

function App() {
  return (
    <AuthProvider>
      <CurrencyGate>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/register" element={<AuthPage mode="register" />} />
          <Route path="/certificate/:no" element={<Certificate />} />
          <Route path="/watch/:token" element={<Watch />} />
          <Route path="/payment/success" element={<PaymentResult />} />
          <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
          <Route path="/app" element={<AppLayout />}>
            <Route index element={<RoleHome />} />
            <Route path="staff" element={<StaffHome />} />
            <Route path="resume" element={<Resume />} />
            <Route path="academy" element={<Academy />} />
            <Route path="learn/:slug" element={<Learn />} />
            <Route path="jobs" element={<JobBoard />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="timesheet" element={<Timesheet />} />
            <Route path="employer" element={<EmployerHome />} />
            <Route path="employer/jobs" element={<EmployerJobs />} />
            <Route path="employer/jobs/:id" element={<JobDetail />} />
            <Route path="team" element={<Team />} />
            <Route path="train-staff" element={<TrainStaff />} />
            <Route path="admin" element={<AdminHome />} />
            <Route path="admin/content" element={<CourseContent />} />
            <Route path="admin/progress" element={<LearnerProgress />} />
            <Route path="admin/videos" element={<AdminVideos />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
      </CurrencyGate>
    </AuthProvider>
  );
}

export default App;
